import DepartureStationPopover
    from "@Pages/stationToStation/features/departureStationPopover/components/DepartureStationPopover";
import BusChangePopover from "@Pages/stationToStation/features/busChangePopover/components/BusChangePopover";
import React from "react";
import BestPriceRouteType from "@Pages/stationToStation/types/BestPriceRoute.type";
import ConnectionDivider from "@Generic/station/ConnectionDivider";

interface BestPriceOnDateRouteStationsProps {
    route: BestPriceRouteType,
    index: number,
    departureTime: string,
    arrivalTime: string
}

const BestPriceOnDateRouteStations = (props: BestPriceOnDateRouteStationsProps) => {
    const {
        route,
        index,
        departureTime,
        arrivalTime,
    } = props

    return (
        <>
            <div className="gb--route-element gb--route-station gb--departure gb--limit-portal-width">
                <DepartureStationPopover
                    departureTime={departureTime}
                    departureStation={route.departureStationName}
                    routeId={route.id}
                />
            </div>

            <div className="gb--route-element gb--connect">
                <span className="gb--route-time">{route.travelTime}</span>
                <ConnectionDivider
                    hasStopover={!!route.busChange.length}
                />
                {!!route.busChange.length && (
                    <BusChangePopover
                        routeId={route.id}
                        stops={route.busChange}
                        index={index}
                    />
                )}
                {!route.isApi && !route.busChange.length && (
                    <span className="gb--connect__bus-change">
                        DIRECT
                    </span>
                )}
            </div>

            <div className="gb--route-element gb--route-station">
                <span className="gb--emphasize gb--emphasize-default gb--route-time">
                    {arrivalTime}
                </span>
                <span className="gb--truncate">{route.destinationStationName}</span>
            </div>
        </>
    )
}

export default BestPriceOnDateRouteStations